export default {
    columns         : _.map(['2','12','4','3','6'], id=>({id: id/*, aggregate: null*/})),
    showSubfolders  : true,
    groupBy1        : {
        fieldId         : undefined,
        sortDirection   : 'asc',
        params          : {}
    },
    groupBy2        : {
        fieldId         : gd.fields.task.statusId.fieldId,
        sortDirection   : 'asc',
        params          : {}
    },
    groupingType    : 'single', // single or double grouping
    sortBy          : null,  // current sort by column value
    filters         : {},
}
